import React from 'react';
import styled from 'styled-components';
import CardMedia from './base/card-media';
import CardHeader from './base/card-header';
import CardHorizontalBlock from './base/card-horizontal-block';
import Card from './base/card';
import CardBody from './base/card-body';
import CardBanner from './base/card-banner';
import { CardTypes } from './card-types';

const VerticalCardIconWrapper = styled.div`
	position: absolute;
	top: 15px;
	right: 15px;
`;

const VertialCard: React.FC<CardTypes> = ({
	cardMediaSrc,
	cardMediaSrcSet,
	cardMediaLazyload,
	cardMediaBannerText,
	cardMediaChipText,
	cardMediaChipIcon,
	onCardMediaClick,
	cardMediaPillContent,
	cardHeaderTitle,
	cardHeaderCaption,
	cardHeaderTitleEllipsis,
	cardHeaderCaptionEllipsis,
	cardHeaderActionContent,
	cardFooterContent,
	cardBodyContent,
	cardMediaIconRight,
	cardMediaImageComponent,
	cardBannerContent,
	overflow,
	biggerBorderRadius,
	cardTopRightIcon,
	mediaMargin
}) => (
	<Card overflow={overflow} biggerBorderRadius={biggerBorderRadius}>
		<CardMedia
			src={cardMediaSrc}
			srcSet={cardMediaSrcSet}
			onClick={onCardMediaClick}
			pillContent={cardMediaPillContent}
			iconRight={cardMediaIconRight}
			bannerText={cardMediaBannerText}
			lazyload={cardMediaLazyload}
			chipText={cardMediaChipText}
			chipIcon={cardMediaChipIcon}
			imageComponent={cardMediaImageComponent}
			wrapperMargin={mediaMargin}
		/>

		{cardHeaderTitle || cardHeaderCaption ? (
			<CardHeader
				title={cardHeaderTitle}
				caption={cardHeaderCaption}
				actionContent={cardHeaderActionContent}
				headerTitleEllipsis={cardHeaderTitleEllipsis}
				headerCaptionEllipsis={cardHeaderCaptionEllipsis}
			/>
		) : null}

		{cardBodyContent && <CardBody>{cardBodyContent}</CardBody>}

		{cardFooterContent && (
			<CardHorizontalBlock showGuttersTop showGuttersBetween>
				{cardFooterContent}
			</CardHorizontalBlock>
		)}
		{cardBannerContent && <CardBanner>{cardBannerContent}</CardBanner>}
		{cardTopRightIcon ? <VerticalCardIconWrapper>{cardTopRightIcon}</VerticalCardIconWrapper> : null}
	</Card>
);

export default VertialCard;
